
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Function to set the last activity timestamp
function setLastCartActivity() {
    localStorage.setItem('lastCartActivity', Date.now());
}

// Function to clear the cart
function clearCartdataupdate() {
    fetch('/cart/clear.js', { method: 'POST' })
        .then(response => response.json())
        .then(data => {
            console.log('Cart cleared:', data);
           // window.location.reload(); // Reload the page to reflect the changes
        });
}

// Function to check if the cart should be cleared
function checkCartExpiry() {
    const lastActivity = localStorage.getItem('lastCartActivity');
    if (lastActivity) {
        const currentTime = Date.now();
        const timeDiff = currentTime - parseInt(lastActivity, 10);
        const fiveHours = 5 * 60 * 60 * 1000;

        if (timeDiff > fiveHours) {
            clearCartdataupdate();
        }
    }
}

// Run the check on page load
document.addEventListener('DOMContentLoaded', checkCartExpiry);


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

async checkhangeradded() {
 
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const completeBeltProducts = cart.items.filter(
      (item) =>
        item.handle.includes("complete-belts") ||
        item.handle.includes("women-complete-belts")
    );

    if (completeBeltProducts.length === 0) {
      $(".drawer").load(document.URL + " #CartDrawer");
      return { success: true, message: "No complete belts. Cart drawer refreshed." };
    }

    const totalQuantity = completeBeltProducts.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    const FreeHangerProductId = 41038085324885;
    const updates = {
      [FreeHangerProductId]: totalQuantity > 30000 ? 1 : 0,
    };

    const updateResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });

    const data = await updateResponse.json();

    $(".drawer").load(document.URL + " #CartDrawer");

    return {
      success: true,
      message: "Cart updated successfully with free hanger logic.",
      data,
    };

  } catch (error) {
    console.error("Error updating cart:", error);
    return {
      success: false,
      message: "Error updating cart.",
      error,
    };
  }
}
    
    onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          this.handleErrorMessage();
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          fetch(`/cart/add.js`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } 
              else if (!this.cart) 
              {
                window.location = window.routes.cart_url;
                return;
              }
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal)
              {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } 
              else 
              {
                this.checkhangeradded();
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
           
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            
            });
          
          loaddiscount();
          setLastCartActivity();
    }
    
    handleErrorMessage(errorMessage = false) 
    {
       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
       if (!this.errorMessageWrapper) return;
       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage)
        {
          this.errorMessage.textContent = errorMessage;
        }
    } 
  });
}

